interface Props {
  [key: string]: any
}

export default function StarIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 19" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M10 0.255859L12.2451 7.16569H19.5106L13.6327 11.4362L15.8779 18.346L10 14.0755L4.12215 18.346L6.36729 11.4362L0.489435 7.16569H7.75486L10 0.255859Z"
        fill="none"
      />
    </svg>
  )
}
